import Link from "@whoppah/next/link";
import { useTranslation } from "next-i18next";

import { formatHelpUpdatedDate } from "@/common/utils/help/help-seo.utils";
import { getHelpCategoryPath } from "@/common/utils/help/help-url.utils";
import { Body } from "@/ui/typography/Body";

type HelpArticleMetaProps = {
  categoryTitle?: string | null;
  categorySlug?: string | null;
  updatedAt?: string | null;
  readingTimeMinutes: number;
  locale: string;
};

export const HelpArticleMeta = ({
  categoryTitle,
  categorySlug,
  updatedAt,
  readingTimeMinutes,
  locale,
}: HelpArticleMetaProps) => {
  const { t } = useTranslation("common");
  const formattedDate = updatedAt
    ? formatHelpUpdatedDate(updatedAt, locale)
    : "";

  return (
    <Body as="p" className="mt-3 text-sm text-grey-500">
      {categoryTitle && categorySlug ? (
        <>
          <Link
            href={getHelpCategoryPath(categorySlug)}
            className="text-brand-500 underline focus:outline-none focus-visible:ring-2 focus-visible:ring-curious-200"
          >
            {categoryTitle}
          </Link>
          <span aria-hidden> · </span>
        </>
      ) : null}
      {formattedDate ? (
        <>
          {t("help-updated", "Updated {{date}}", { date: formattedDate })}
          <span aria-hidden> · </span>
        </>
      ) : null}
      {t("help-reading-time", "{{count}} min read", {
        count: readingTimeMinutes,
      })}
    </Body>
  );
};
